export default "/assets/provider-badge-autocx.v2.svg";